import React, { PropTypes } from 'react';
import Logo from 'common/Logo';

const CollectionBucketHeader = ({ iconHref, name }) => (
    <header className="section-header">
        { iconHref ? <Logo iconHref={iconHref} className={'section-header_logo'} /> : null }
        <h1 className="section-header_title">{name}</h1>
    </header>
);

CollectionBucketHeader.propTypes = {
    name: PropTypes.string,
    iconHref: PropTypes.string
};

export default CollectionBucketHeader;



// WEBPACK FOOTER //
// ./app/common/page/buckets/CollectionBucketHeader.js